export enum DocumentState {
  Uploaded,
  Failed,
  Uploading,
}
export interface DocumentInfo {
  file?: File;
  state?: DocumentState;
  uid?: string | null;
  documentName?: string;
  documentClass?: string;
}
